import React from "react";
import AboutItem from "../FeaturedAbout/AboutItem";
import cx from "classnames";
import styles from "./Sustainability.module.scss";
import Markdown from "@components/Markdown";
import { usePageContext } from "@providers/PageProvider";
import { sustainabilityPage } from "@utils/helper";
import _ from "lodash";
import { OPPOSITE_POSITION } from "@utils/constant";

const COMPONENTS = {
  strong: ({ children }: any) => (
    <strong style={{ fontWeight: 405 }}>{children}</strong>
  ),
  ul: ({ children }: any) => (
    <div className="flex flex-col gap-6">{children}</div>
  ),
  li: ({ children }: any) => (
    <div className="flex">
      <div className="px-2">{`•`}</div>
      <div>{children}</div>
    </div>
  ),
};
export default function SustainableItems() {
  const { pageData } = usePageContext();
  const sustainableItems = sustainabilityPage.formatSustainableItems(pageData);
  return (
    <div
      data-scroll-section
      className={cx(
        "flex flex-col items-center",
        styles.sustainableItemsContainer
      )}
    >
      {_.map(sustainableItems, (item: any, index: number) => {
        const itemIndex = (index + 1) % 4 === 0 ? 4 : (index + 1) % 4;
        return (
          <AboutItem
            key={index}
            // shouldReadMore
            className={cx(styles[`sustainableItem${itemIndex}`])}
            images={[
              {
                ..._.get(item, "image"),
                placement: _.get(item, "imagePosition"),
              },
            ]}
            aside={{
              placement: OPPOSITE_POSITION[_.get(item, "imagePosition")],
              className: cx(styles[`asideSustainableItem${itemIndex}`]),
              content: {
                className: cx(styles[`contentSustainableItem${itemIndex}`]),
                title: _.get(item, "title"),
                text: (
                  <div className="flex flex-col mt-4 gap-7">
                    <Markdown
                      components={COMPONENTS}
                      content={_.get(item, "content")}
                    />
                  </div>
                ),
              },
            }}
          />
        );
      })}
    </div>
  );
}
